function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M376,144c-3.92,52.87-44,96-88,96s-84.15-43.12-88-96c-4-55,35-96,88-96S380,90,376,144Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,304c-87,0-175.3,48-191.64,138.6-2,10.92,4.21,21.4,15.65,21.4H464c11.44,0,17.62-10.48,15.65-21.4C463.3,352,375,304,288,304Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 176,
    x2: 88,
    y2: 288,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 232,
    x2: 32,
    y2: 232,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddOutline);
export default __webpack_public_path__ + "static/media/person-add-outline.9a41884f35a14e465b58c4da553c0e7f.svg";
export { ForwardRef as ReactComponent };